import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const WhyCommunityPortal = () => {
  return (
    <>
      <Navbar />
      <div className="px-6 py-12 max-w-5xl mx-auto text-gray-800">
        <h1 className="text-4xl font-bold mb-4 text-center bg-gradient-to-r from-slate-400 via-zinc-400 to-stone-800 text-transparent bg-clip-text">
          Why People Should Use Community Portal
        </h1>
        <p className="text-center text-gray-500 text-lg mb-10">Transforming Neighborhood Living</p>

        <section className="space-y-12">
          <div>
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Rebuilding Neighborhood Connections</h2>
            <p className="mb-3">Social isolation has become increasingly common in residential communities. Many homeowners report knowing only a handful of neighbors, missing opportunities for meaningful connections and mutual support. Community Portal addresses this fundamental need by providing verified, secure spaces where neighbors can:</p>
            <ul className="list-disc list-inside space-y-2 pl-4 text-gray-700">
              <li>Connect through community-wide and interest-based group chats</li>
              <li>Organize and discover local clubs, carpools, and social initiatives</li>
              <li>Share important neighborhood updates in real-time</li>
              <li>Build trusted relationships through verified profiles</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Streamlining HOA and Resident Communication</h2>
            <p className="mb-3">The frustration of missed announcements, lost emails, and confusing paper notices is a common pain point in managed communities. Community Portal transforms this experience by:</p>
            <ul className="list-disc list-inside space-y-2 pl-4 text-gray-700">
              <li>Creating a centralized hub for all important community information</li>
              <li>Enabling two-way communication between residents and HOA boards</li>
              <li>Providing transparent access to community documents, policies, and financial information</li>
              <li>Offering digital tools for surveys, polls, and resident feedback</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Simplifying Community Resource Management</h2>
            <p className="mb-3">Community amenities often sit underutilized due to complicated booking processes and lack of awareness. Community Portal solves this by offering:</p>
            <ul className="list-disc list-inside space-y-2 pl-4 text-gray-700">
              <li>Real-time visibility into amenity availability</li>
              <li>Simple digital booking systems</li>
              <li>Clear information about rules and usage policies</li>
              <li>Automated notifications and reminders</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Creating a Trusted Local Marketplace</h2>
            <p className="mb-3">The desire to buy, sell, and exchange locally is strong, but platforms like Facebook Marketplace or Craigslist lack community verification and neighborhood focus. Community Portal offers:</p>
            <ul className="list-disc list-inside space-y-2 pl-4 text-gray-700">
              <li>A secure marketplace exclusive to verified community members</li>
              <li>Local services exchange for everything from pet sitting to lawn care</li>
              <li>Simple reporting tools to maintain safety and quality</li>
              <li>Optional payment processing for seamless transactions</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Enhancing Safety and Security</h2>
            <p className="mb-3">Community safety concerns often lack appropriate channels for sharing. Community Portal provides:</p>
            <ul className="list-disc list-inside space-y-2 pl-4 text-gray-700">
              <li>Dedicated spaces for reporting security concerns</li>
              <li>Lost and found functionality</li>
              <li>Simplified issue reporting for community problems</li>
              <li>Moderation tools to manage sensitive information</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Simplifying Financial Management</h2>
            <p className="mb-3">Managing HOA payments and understanding community finances can be frustrating. Community Portal brings transparency and convenience through:</p>
            <ul className="list-disc list-inside space-y-2 pl-4 text-gray-700">
              <li>Online payment portals for dues and fees</li>
              <li>Clear financial reporting accessible to all residents</li>
              <li>Historical payment records and documentation</li>
              <li>Simplified expense tracking</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Building Communities That Last</h2>
            <p className="mb-3">Beyond solving immediate practical problems, Community Portal is designed with long-term community health in mind:</p>
            <ul className="list-disc list-inside space-y-2 pl-4 text-gray-700">
              <li>New resident onboarding creates welcome experiences</li>
              <li>Modular design allows communities to activate only the features they need</li>
              <li>Multi-tenancy architecture ensures privacy between different communities</li>
              <li>Scalable systems grow with your community's needs</li>
            </ul>
          </div>

          <blockquote className="bg-gray-100 border-l-4 border-indigo-400 p-4 italic text-gray-700">
            “To create a connected world where every homeowner feels supported, informed, and engaged within their local community.”
          </blockquote>

          <div className="mt-8 text-center">
            <p className="text-lg font-medium">Ready to transform your neighborhood experience?</p>
            <button className="mt-3 bg-indigo-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-indigo-700">
              Learn More About Community Portal
            </button>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default WhyCommunityPortal;
